// extracted by mini-css-extract-plugin
export default {"container":"container--P5sGC","checkbox":"checkbox--sw9QR","info":"info--J43O2"};